import { PropsWithChildren, useEffect } from 'react';
import { observer } from 'mobx-react';
import cls from 'classnames';

import { useAppStore } from '@/common/stores/AppStore';

import styles from './Layout.module.css';

export type LayoutProps = PropsWithChildren<{
  className?: string;
  twoColumn?: boolean;
  strictHeight?: boolean;
  sidebarWidth?: number;
  isFullHeight?: boolean;
}>;

function Layout(props: LayoutProps) {
  const {
    className,
    children,
    twoColumn = false,
    strictHeight = false,
    isFullHeight,
    sidebarWidth,
  } = props;
  const { isPhone, isSidebarOpened } = useAppStore();

  useEffect(() => {
    if (strictHeight) {
      document.body.classList.add(styles.layoutStrictHeight);
    } else {
      document.body.classList.remove(styles.layoutStrictHeight);
    }

    return () => {
      document.body.classList.remove(styles.layoutStrictHeight);
    };
  }, [strictHeight]);

  const shouldShowSidebar = isSidebarOpened && twoColumn && !isPhone;

  return (
    <div
      aria-label="Layout"
      className={cls(
        styles.layout,
        {
          [styles.layoutTwoColumn]: twoColumn,
          [styles.layoutOneColumn]: !twoColumn,
          [styles.layoutStrictHeight]: strictHeight,
          [styles.layoutWithSidebar]: twoColumn && shouldShowSidebar,
          [styles.layoutWithoutSidebar]: twoColumn && !shouldShowSidebar,
          [styles.fullHeight]: isFullHeight,
        },
        className,
      )}
      // @ts-ignore
      style={{ '--sidebar-width': sidebarWidth ? `${sidebarWidth}rem` : null }}
    >
      {children}
    </div>
  );
}

export default observer(Layout);
